'use strict';

const { pubdb } = Function('return this')();
const {
    $, window, mustache, newest_if_year, ajax_post, echo, path_root,
    journal_extras_year, ajax_get, display_when_ready, next_tick, kb_ev_enter, ajax_success_handler,
} = pubdb;
const { alert } = window;


function success (data) {
    var dest = $('#pubdb_data');
    dest.html(mustache(
'<table style="width: 100%; background-color: white;" class="tablesorter">' +
'<colgroup>' +
    '<col style="white-space:nowrap" />' +
    '<col style="white-space:nowrap" />' +
    '<col style="white-space:nowrap" />' +
    '<col style="white-space:nowrap" />' +
    '<col style="white-space:nowrap" />' +
    '<col style="white-space:nowrap" />' +
    '<col style="white-space:nowrap" />' +
    '<col/>' +
'</colgroup>' +
'<thead>' +
    '<tr>' +
        '<th style="min-width: 4em">Refs</th>' +
        '<th style="min-width: 4em">Jahr</th>' +
        '<th style="min-width: 3em"><abbr title="Impact Factor">IF</abbr></th>' +
        '<th style="min-width: 3em"><abbr title="5-Jahres-Impact-Factor">IF5</abbr></th>' +
        '<th style="min-width: 8em">OpenAccess</th>' +
        '<th style="min-width: 4em"><abbr title="Quartil">Qu.</abbr></th>' +
        '<th style="min-width: 6em">ISSN</th>' +
        '<th>Zeitschrift</th>' +
    '</tr>' +
'</thead>' +
'<tbody>' +
    '{{#data}}' +
        '<tr data-jid="{{8}}" data-year="{{1}}" class="jid_{{8}}' +
                                                     ' year_{{1}}' +
                                                     ' _if_{{#2}}yes{{/}}' +
                                                     ' _if5_{{#3}}yes{{/}}' +
                                                     ' _openaccess_{{#4}}yes{{/}}' +
                                                     ' _quartile_{{#9}}yes{{/}}' +
                                                     ' _issn_{{#5}}{{-if 5 !== "XXXXYYYY"}}yes{{-endif}}{{/}}' +
                                                     '">' +
            '<td class="-ref" title="Refs">{{0}}</td>' +
            '<td class="-year" title="Jahr">{{1}}</td>' +
            '<td class="-ifactor" title="Impact Factor">{{2}}</td>' +
            '<td class="-ifactor5" title="5-Jahres Impact Factor">{{3}}</td>' +
            '<td class="-openaccess" title="Open Access">{{4}}</td>' +
            '<td class="-quartile" title="Quartil">{{9}}</td>' +
            '<td class="-issn" title="ISSN">{{#5}}' +
                '<a class="pubdb-issn-link" href="{{> PATH_ROOT}}/issn/{{5}}/">{{> DISPLAY_ISSN|5}}</a><br />' +
            '{{/}}</td>' +
            '<td class="-title" title="Journal">' +
                '<a href="{{> PATH_ROOT}}/journal/{{8}}/" target="_blank">{{7}}</a>' +
                '{{#6}}<br/>Abkürzung: {{6}}{{/}}' +
            '</td>' +
        '</tr>' +
    '{{/data}}' +
'</tbody>' +
'</table>', {data:data}));
    dest.find('tr._if_').each(function () {
        var self = $(this);
        if (+self.data('year') > newest_if_year) {
            self.removeClass('_if_').addClass('_if_yes');
        }
    });
    dest.find('table').tablesorter();
    dest.find('tr').hover(function () {
        var self = $(this);
        dest.find('tbody tr.jid_' + self.data('jid')).addClass('current_journal');
        dest.find('tbody tr.year_' + self.data('year')).addClass('current_year');
    }, function () {
        dest.find('tbody tr.current_journal').removeClass('current_journal');
        dest.find('tbody tr.current_year').removeClass('current_year');
    });
    dest.find('tbody').click(function (ev) {
        var e = /(?:^|\s)-(ifactor|ifactor5|openaccess|quartile)\b/.exec(ev.target.className);
        if (e) {
            ev.preventDefault();
            startEdit($(ev.target.parentNode), e[1]);
        }
    });

    $('#hide_data :checkbox').each(function (index) {
        var self = $(this);
        self.change(function () {
            var fun = (self.prop('checked') ? 'add' : 'remove') + 'Class';
            var arg = 'no_' + ['if', 'openaccess', 'issn'][index % 3] + (index > 2 ? '_yes' : '_');
            dest[fun](arg);
        });
    }).prop('checked', false);
}

function startEdit (row, clicked_into) {
    if (row.data('editing') === 'true') {
        return;
    }
    row.data('editing', 'true');

    var ifactor_td = row.find('.-ifactor');
    var ifactor_orig = ifactor_td.text();
    var ifactor_edit = $('<div/>', {
        text: ifactor_orig,
        contenteditable: true,
        css: {
            margin: 0,
            lineHeight: '1em',
            padding: '0 0 1em 0',
            width: '4em',
            height: '1em',
            'border-bottom': '2px dotted green'
        }
    });
    ifactor_td.html(ifactor_edit);

    var ifactor5_td = row.find('.-ifactor5');
    var ifactor5_orig = ifactor5_td.text();
    var ifactor5_edit = $('<div/>', {
        text: ifactor5_orig,
        contenteditable: true,
        css: {
            margin: 0,
            lineHeight: '1em',
            padding: '0 0 1em 0',
            width: '4em',
            height: '1em',
            'border-bottom': '2px dotted green'
        }
    });
    ifactor5_td.html(ifactor5_edit);

    var openaccess_td = row.find('.-openaccess');
    var openaccess_orig = openaccess_td.text();
    var openaccess_edit = $('<select/>', {
        append: [
            $('<option/>', {
                val: 'gold',
                text: 'Goldener Weg'
            }),
            $('<option/>', {
                val: 'green',
                text: 'Grüner Weg'
            }),
            $('<option/>', {
                val: 'fake',
                text: '"Fake"'
            }),
            $('<option/>', {
                val: 'na',
                text: 'kein OA'
            }),
            $('<option/>', {
                val: '',
                text: 'nicht gesetzt'
            })
        ],
        css: {
            margin: 0,
            padding: 0,
            width: '100%'
        }
    }).val(openaccess_orig);
    openaccess_td.html(openaccess_edit);

    var quartile_td = row.find('.-quartile');
    var quartile_orig = quartile_td.text();
    var quartile_edit = $('<select/>', {
        append: [
            $('<option/>', {
                val: '1',
                text: 'Q1'
            }),
            $('<option/>', {
                val: '2',
                text: 'Q2'
            }),
            $('<option/>', {
                val: '3',
                text: 'Q3'
            }),
            $('<option/>', {
                val: '4',
                text: 'Q4'
            }),
            $('<option/>', {
                val: '',
                text: 'nicht gesetzt'
            })
        ],
        css: {
            margin: 0,
            padding: 0,
            width: '100%'
        }
    }).val(quartile_orig);
    quartile_td.html(quartile_edit);

    row.keydown(function (ev) {
        if (kb_ev_enter(ev)) {
            ev.preventDefault();
            next_tick(stopEdit);
        }
    });

    function stopEdit () {
        var ifactor_new = ifactor_edit.text().trim().replace(/,+/g, '.');
        var ifactor5_new = ifactor5_edit.text().trim().replace(/,+/g, '.');
        var openaccess_new = openaccess_edit.val().trim();
        var quartile_new = quartile_edit.val().trim();

        if (isNaN(+ifactor_new)) {
            alert('Fehlerhafter Impact-Factor: konnte nicht als Zahl ausgewertet werden.')
            return;
        }
        if (isNaN(+ifactor5_new)) {
            alert('Fehlerhafter 5-Jahres-Impact-Factor: konnte nicht als Zahl ausgewertet werden.')
            return;
        }
        if (ifactor_new && +ifactor_new && (+ifactor_new).toFixed(3) !== ifactor_new) {
            alert('Bitte geben Sie den Impact-Factor auf genau drei Nachkommenstellen an.');
            return;
        }
        if (ifactor5_new && +ifactor5_new && (+ifactor5_new).toFixed(3) !== ifactor5_new) {
            alert('Bitte geben Sie den 5-Jahres-Impact-Factor auf genau drei Nachkommenstellen an.');
            return;
        }

        var main_form = $('#main_form');
        var data = {
            jid: row.data('jid'),
            year: row.data('year'),
            ifactor: ifactor_new && +ifactor_new,
            ifactor5: ifactor5_new && +ifactor5_new,
            open_access: openaccess_new,
            quartile: quartile_new && +quartile_new,
            csrf_token: main_form.find('[name=csrf_token]').val()
        };
        ajax_post(main_form.attr('action'), data, saveSuccess, error);
    }

    function saveSuccess (resp) {
        if (!ajax_success_handler(resp)) {
            return;
        }
        const { data } = resp;

        row.unbind('keydown');
        row.data('editing', '');

        ifactor_orig = data.impact_factor || '';
        ifactor5_orig = data.impact_factor5 || '';
        ifactor_td.empty().text(ifactor_orig);
        ifactor5_td.empty().text(ifactor5_orig);
        if (ifactor_orig) {
            row.addClass('_if_yes');
            if (row.data('year') <= newest_if_year) {
                row.removeClass('_if_').addClass('_if_yes');
            }
        } else {
            row.addClass('_if_').removeClass('_if_yes');
        }
        if (ifactor5_orig) {
            row.addClass('_if_yes');
            if (row.data('year') <= newest_if_year) {
                row.removeClass('_if5_').addClass('_if_yes');
            }
        } else {
            row.addClass('_if5_').removeClass('_if_yes');
        }

        openaccess_orig = data.open_access || '';
        openaccess_td.empty().text(openaccess_orig);
        if (openaccess_orig) {
            row.addClass('_openaccess_yes').removeClass('_openaccess_');
        } else {
            row.addClass('_openaccess_').removeClass('_openaccess_yes');
        }

        quartile_orig = data.quartile || '';
        quartile_td.empty().text(quartile_orig);
        if (quartile_orig) {
            row.addClass('_quartile_yes').removeClass('_quartile_');
        } else {
            row.addClass('_quartile_').removeClass('_quartile_yes');
        }
    }

    next_tick(function () {
        ({
            'ifactor': ifactor_edit,
            'ifactor5': ifactor5_edit,
            'openaccess': openaccess_edit,
            'quartile': quartile_edit,
        }[clicked_into] || { focus: function () {} }).focus();
    });
}

function error (data, err, xhr) {
    echo('warn', 'Fehler (' + data.statusText + ') - bitte versuchen Sie es erneut');
}

var ajax_url = path_root + '/journal/extras/';
if (journal_extras_year) {
    ajax_url += journal_extras_year + '/';
}
ajax_get(ajax_url, display_when_ready(success), display_when_ready(error));
